<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"
        />

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 mb-4">Menu</p>
            <reference
                create-text="Create new menu and link menu to this page"
                link-text="Link an existing menu"
                v-model="form.menu"
                model-data="Menu Document"
                :error="errors.menu_id ? errors.menu_id[0] : null"
                :deletable="false"
                :creatable="false"
                :linkable="false"
            />
        </div>

        <div
            class="border bg-white rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 mb-4">Casino Review</p>
            <reference
                create-text="Create new casino review and link casino review to this page"
                link-text="Link an existing casino review"
                v-model="form.casino_review"
                model-data="Casino Review"
                :creatable="false"
                :error="errors.casino_review_id ? errors.casino_review_id[0] : null"
                :language="form.language"
                :query="{
                    status_id: 1,
                }"
            />
        </div>

        <media-reference
            :language="form.language"
            v-model="form.logo"
            class="mt-3"
            label="Logo"
            name="logo_id"
            :media-types="['OperatorLogo', 'Logo']"
            :error="errors.logo_id ? errors.logo_id[0] : null"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";
export default {
    name: "MenuTopChoiceForm",
    mixins: [crudForm],
    data() {
        return {
            form: {
                menu_id: this.getFormData("menu_id"),
                menu: this.getFormData("menu"),
                casino_review_id: this.getFormData("casino_review_id"),
                casino_review: this.getFormData("casino_review"),
                logo_id: this.getFormData("logo_id"),
                logo: this.getFormData("logo"),
            },
        };
    },
    watch:{
        "form.menu": function (newValue) {
            this.form.menu_id = newValue ? newValue.id : null;
        },
        "form.casino_review": function (newValue) {
            this.form.casino_review_id = newValue ? newValue.id : null;
        },
        "form.logo": function (newValue) {
            this.form.logo_id = newValue ? newValue.id : null;
        },
    }
};
</script>
